import { cva } from 'class-variance-authority'

export const columnBlockVariants = cva(
  ['grid', 'grid-cols-1', 'gap-4', 'my-4', 'w-full'],
  {
    variants: {
      columnCount: {
        2: 'md:grid-cols-2',
        3: 'md:grid-cols-3',
        4: 'md:grid-cols-4',
      },
    },
    defaultVariants: {
      columnCount: 2,
    },
  }
)
